import React, { useRef, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';

export default function CantidadEscaneadaDialog({ producto, inicial, disponible, onCancel, onConfirm, busy = false, error = '' }) {
  const [cantidad, setCantidad] = useState(String(inicial));
  const burst = useRef(null);
  const numero = Number(cantidad);
  const valido = /^\d+$/.test(cantidad) && Number.isSafeInteger(numero) && numero > 0 && numero <= disponible;
  const submit = event => { event.preventDefault(); if (valido && !busy) onConfirm(numero); };
  // Los lectores de teclado envían una ráfaga seguida de Enter. No permitir
  // que una lectura extra se interprete como cantidad y confirme la ventana.
  const guard = event => {
    if (event.key.length === 1 && !event.ctrlKey && !event.altKey && !event.metaKey) {
      const now = performance.now();
      const previous = burst.current;
      burst.current = previous && now - previous.last < 35
        ? { ...previous, last: now, count: previous.count + 1 }
        : { last: now, count: 1, before: cantidad };
    } else if (event.key === 'Enter') {
      if (burst.current?.count >= 3 && performance.now() - burst.current.last < 80) {
        event.preventDefault(); event.stopPropagation(); setCantidad(burst.current.before);
      }
      burst.current = null;
    } else { burst.current = null; }
  };
  return <Dialog open onClose={() => { if (!busy) onCancel(); }} fullWidth maxWidth="xs" onKeyDownCapture={guard}>
    <form onSubmit={submit}>
      <DialogTitle>Cantidad total</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>{producto.descripcion}</Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField autoFocus fullWidth label="Cantidad total" value={cantidad} disabled={busy}
          onFocus={event => event.target.select()}
          onChange={event => setCantidad(event.target.value.replace(/[^\d]/g, ''))}
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
          error={!valido} helperText={`Disponible para esta línea: ${disponible}. Escribe el total, no las unidades adicionales.`} sx={{ mt: 1 }} />
      </DialogContent>
      <DialogActions><Button onClick={onCancel} disabled={busy}>Cancelar</Button><Button type="submit" variant="contained" disabled={!valido || busy}>{busy ? 'Procesando…' : 'Confirmar cantidad'}</Button></DialogActions>
    </form>
  </Dialog>;
}
